export const CUSTOMIZATIONS_DATA_GRABS = {
    textFieldWrapperDataGrab: 'product-customizations-text-field',
    textFieldLabelDataGrab: 'product-customizations-text-field-label',
    textAreaDataGrab: 'product-customizations-text-field-textarea',
    textAreaPlaceholderDataGrab:
        'product-customizations-text-field-placeholder',
    counterDataGrab: 'product-customizations-text-field-counter',
    checkboxWrapperDataGrab: 'product-customizations-checkbox-wrapper',
    checkboxLabelDataGrab: 'product-customizations-checkbox-label',
    choicesContainerDataGrab: 'product-customizations-choices-container',
    choiceLabelDataGrab: 'product-customizations-choice-label',
    choiceDataGrab: 'product-customizations-choice',
    choiceCheckedDataGrab: 'product-customizations-choice-checked',
};

export const MAX_TEXT_FIELD_LENGTH = 320;
